var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDirectDebit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 90,
    viewBox: "0 0 283 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6396_24068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.97 43.8402C103.97 17.2302 88 5.69015 69.83 1.62015V0.240152C102.88 1.97015 127.09 22.0802 127.08 45.0902C127.07 71.3602 98.58 90.0902 63.45 90.0702C28.31 90.0502 -0.00999735 69.8702 2.64749e-06 45.0102C0.0100026 18.9202 24.76 0.090153 66.93 0.120153L66.92 32.5302L56.95 32.3302C35.59 33.0702 10.84 42.3702 10.84 54.8902C10.84 68.6602 34.32 85.2202 62.52 85.2402C85.33 85.2402 103.96 68.7102 103.97 43.8402Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.72 81.5004C54.61 80.6304 39.05 72.5504 39.05 58.6404C39.05 44.8703 52.32 34.9004 66.73 34.3604L66.72 81.5004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.63 18.9605L254.99 22.5405C253.33 21.9805 237.53 18.2805 237.3 30.0405C237.12 39.4605 251.5 38.3005 254.79 37.4205L255.16 41.3205C244.35 44.3405 229.99 41.0405 229.7 29.9405C229.36 17.1405 248.35 15.5605 255.63 18.9605Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.8 41.9809V21.8109L257.09 21.8009V17.9609L283.2 17.9709V21.8209H273.67V41.9909L266.8 41.9809Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.56 17.7402L227.82 17.7602L227.81 21.7802H214.99L214.98 41.7602L208.55 41.7502L208.56 17.7402Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.06 27.8701H214.38V31.9001H227.06V27.8701Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.71 37.7402H214.38V41.7702H227.71V37.7402Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.67 17.7705H165.48V41.6805H172.67V17.7705Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.61 17.9404H132.42V41.8504H139.61V17.9404Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.2 41.8604L138.66 37.9804L144.04 37.8304C150.28 37.8304 154.05 34.3604 154.05 29.7804C154.05 24.2404 149.02 21.6204 145.15 21.6204L138.61 21.2604L137.71 17.9404L145.31 17.9504C154.05 17.9604 161.61 22.6404 161.61 30.0204C161.61 37.4404 154.04 41.8704 145.3 41.8604H137.2Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.6 47.9902H132.41V71.9002H139.6V47.9902Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.19 71.9005L138.65 68.0205L144.03 67.8705C150.27 67.8705 154.04 64.4005 154.04 59.8205C154.04 54.2805 149.01 51.6605 145.14 51.6605L138.6 51.3005L137.69 47.9805H145.29C154.03 47.9905 161.59 52.6705 161.59 60.0505C161.59 67.4705 154.02 71.9005 145.29 71.8905L137.19 71.9005Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.05 46.1309H205.11V72.0509H212.05V46.1309Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.44 54.5205H243.5V72.2905H250.44V54.5205Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.44 46.2109H243.5V50.7909H250.44V46.2109Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.94 67.6202L266.95 49.9502H274.04L274.03 66.8102C274.03 69.0702 277.9 69.7802 280.12 69.0302V72.9602C275.34 74.0702 266.94 73.9102 266.94 67.6202Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.92 54.5303H261.41V58.3103H279.92V54.5303Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.59 64.2301C176.94 71.1301 190.83 68.6701 192.69 66.7101V70.8901C189.92 72.2001 186.36 72.3501 182.4 72.3401C175.19 72.3401 169.35 68.6601 169.35 62.6701C169.35 57.3301 174.74 53.1101 182.41 53.1201C188.32 53.1201 194.86 55.9001 194.41 64.2501L176.59 64.2301ZM176.64 60.9201L187.81 60.9001C187.51 58.2001 185.5 56.6901 182.48 56.6901C179.2 56.6901 176.74 57.9401 176.64 60.9201Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.31 24.0807C202.31 29.7707 196.95 30.2007 196.67 30.2207C197.52 30.7707 198.29 31.8807 198.33 31.9307L203.84 41.7507L196.33 41.7407L192.54 34.5907C192.49 34.4707 191.53 32.1207 188.61 32.1707H185.95V41.7307H178.82L178.83 17.7207L191.72 17.7307C195.33 17.7307 202.31 18.6507 202.31 24.0807ZM185.9 28.1007H190.58C192.44 28.1007 195.11 26.8907 195.11 24.9107C195.11 22.7207 192.91 21.6607 190.68 21.6607H185.9V28.1007Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.94 63.1209C209.94 56.5009 214.32 53.8308 220.58 53.8408C226.43 53.8408 231.12 56.9708 231.12 63.1308C231.12 69.1508 226.38 72.7209 220.53 72.7109C213.76 72.7209 209.94 69.8409 209.94 63.1209ZM212 63.3309C212 66.3509 214.72 68.7909 218.09 68.8009C221.45 68.8009 224.18 66.3608 224.18 63.3408C224.18 60.3208 221.46 57.8809 218.09 57.8709C214.73 57.8709 212 60.3109 212 63.3309Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6396_24068"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 283,
    height: 90,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectDebit);
export default __webpack_public_path__ + "static/media/direct-debit.0ffd4f7218a98739cb10833dd545ece2.svg";
export { ForwardRef as ReactComponent };